export const INSIDER_CATEGORY_OPTIONS = [
    'BSO News',
    'Market Insights',
    'Announcements',
    'Tips & Guides',
    'BSO Stories',
    'Meet the Community',
    'Partner Spotlight',
] as const

export const categoryOptionsForValue = (value: unknown): string[] => {
    const category = typeof value === 'string' ? value.trim() : ''
    return category && !INSIDER_CATEGORY_OPTIONS.includes(category as typeof INSIDER_CATEGORY_OPTIONS[number])
        ? [...INSIDER_CATEGORY_OPTIONS, category]
        : [...INSIDER_CATEGORY_OPTIONS]
}

export const isResizeObserverLoopMessage = (value: unknown): boolean => value === 'ResizeObserver loop completed with undelivered notifications.' || value === 'ResizeObserver loop limit exceeded'

export const progressPercentage = (done: number, total: number): number => total > 0 ? Math.min(100, Math.max(0, Math.round((done / total) * 100))) : 0
